import Model, { attr, belongsTo } from "@ember-data/model";

export default class DnssecRecordModel extends Model {
  @attr("number") flags;
  @attr("number") algorithm;
  @attr("string") algorithmname;
  @attr("number") digesttype;
  @attr("string") digesttypename;
  @attr("string") digest;
  @attr("string") dnskey;
  @attr("number") keytag;
  @attr("string") status;
  @attr("string") origin;
  @attr("date") createdat;

  @belongsTo("dns-domain", { async: false, inverse: "dnssecRecords" }) domain;
}
